export default () => ({
  page: null,
  errorState: [],
  email: "",
  formPosted: false,
  init() {
    this.page = window.location.pathname;
  },
  checkErrorState(errorState) {
    if ([...this.errorState].includes(errorState)) {
      return true;
    }
    return false;
  },
  submitPasswordForm() {
    const form = document.getElementById("customer_password");
    const email = document.getElementById("RecoverEmail");
    this.email = email.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    this.errorState = [];

    if (!emailRegex.test(email.value)) {
      this.errorState.push("email_invalid");
      return;
    }

    const formData = new FormData(form);

    fetch("/account/recover", {
      method: "POST",
      body: formData,
    }).then((response) => {
      if (response.status === 429) {
        return;
      }
      this.formPosted = true;
    });
  },
});
